module.exports = __webpack_public_path__ + "img/4.82b819fd.png";